import React from 'react';
import {
	type JSErrorBoundaryProps,
	JSErrorBoundary,
} from '@atlassian/jira-error-boundaries/src/ui/js-error-boundary/JSErrorBoundary.tsx';

export const BulkOperationsErrorBoundary = ({
	id,
	children,
	fallback,
	onError,
}: Partial<JSErrorBoundaryProps> & { id: string }): React.JSX.Element => (
	<JSErrorBoundary
		id={id}
		packageName="jiraBulkOperationsCommon"
		fallback={fallback || 'unmount'}
		teamName="deliveroo"
		onError={onError}
	>
		{children}
	</JSErrorBoundary>
);
